import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarRef as MatSnackBarRef, LegacySimpleSnackBar as SimpleSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatLegacyTabChangeEvent as MatTabChangeEvent, MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { ConfirmationButton, ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { UUID } from 'angular2-uuid';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { CustomerService } from 'app/shared/services/customer.service';
import { FilterDataSource } from 'app/shared/data/filter-data-source';
import { BehaviorSubject } from 'rxjs';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { DomOperationUtilsService } from 'app/shared/utils/dom-operation-utils.service';
import { StringUtils } from 'app/shared/utils/string-utils';
import { FEATURE_IDS, USER_ROLES, UsersService } from 'app/pages/admin/users.service';
import { FormControl, NgForm } from '@angular/forms';
import { UsersInfo, UsersDetailInfo, IFeatures } from 'app/shared/models/users';
import { StatusCodeService } from 'app/shared/services/status-code.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { UiUtilsService } from 'app/shared/utils/ui-utils.service';
import { TranslateService } from '@ngx-translate/core';
import {
    CompositeLocComponent,
    CompositeLocComponentInput,
    CompositeLocCreateInput,
} from 'app/shared/components/map/composite-loc/composite-loc.component';
import { environment } from 'app/environments/environment';
const LOCATION_DETAIL_HINT = 'LOCATION_DETAIL_HINT';
import { RAIN_GAUGE, UnitOfMeasureType } from 'app/shared/constant';
import { IDLE_MESSAGE_MINUTES } from 'app/shared/constant';
import { MapService } from 'app/shared/services/map.service';
import { DateutilService } from 'app/shared/services/dateutil.service';
import { LocationDashboardService } from 'app/shared/services/location-dashboard.service';
import {
    AppQueryParams,
    CollectProcessType,
    Customer,
    customerEditorQueryParam,
    customerQueryParam,
    GetAllRainGaugesParams,
    GetCustomerSummary,
    ProjectDetailsAdditionalFeature,
    sortDirectionParam,
    sortValueParam,
    SUBSCRIPTION_LEVELS,
    SubscriptionLevel,
    userSearchPageIndexParam,
    userSearchPageSizeParam,
    userSearchParam,
} from 'app/shared/models/customer';
import { LocationArgs, Locations, RainLocation } from 'app/shared/models/locations';
import { AddLocationModalData } from 'app/shared/models/add-location';
import { GetUsersResponse } from 'app/shared/models/users-permission';
import { AddLocationComponent } from 'app/shared/components/map/add-location/add-location.component';
import { debounceTime, distinctUntilChanged, finalize, first, map, switchMap, tap } from 'rxjs/operators';
import { GISService } from 'app/shared/services/gis-service';
import { LocationCardService } from 'app/shared/components/location-card/services/location-card.service';
import { AutoCompleteItem } from 'app/shared/models/selectable';
import { IComponentDialog, IComponentDialogConfirmationResult } from 'app/shared/models/component-confirmation';
import { TrackBy } from 'app/shared/utils/track-by';
import { LocationCardContainerDialogComponent } from 'app/shared/components/location-card/components/location-card-container/location-card-container.component';
import { CALCULATION_TYPE_DEFAULTS } from 'app/pages/view-data/calculated-entity/calculated-entity.model';
import { IComponentModalResult } from 'app/shared/models/modal';
import { LocationCardData } from 'app/shared/components/location-card/models/location-card.model';
import { CustomerDetailFeatureComponent } from '../customer-detail-feature/customer-detail-feature.component';
import { CustomerDetailUserEditorComponent } from '../customer-detail-user-editor/customer-detail-user-editor.component';
import { CustomerRainProfileComponent } from '../customer-rain-profile/customer-rain-profile.component';
import { ApiKeyDashboardComponent } from 'app/pages/admin/api-key-dashboard/api-key-dashboard.component';
import { CustomerDetailLocationsEditorComponent } from '../customer-detail-locations-editor/customer-detail-locations-editor.component';
import { AdsPrismGISLayersComponent } from '../ads-prism-gis-layers/ads-prism-gis-layers.component';
import { AdsPrismFtpSweepComponent } from '../ads-prism-ftp-sweep/ads-prism-ftp-sweep.component';
import { PageEvent } from '@angular/material/paginator';
import { CustomerEditorPaginationState, CustomerEditorTabId } from '../customer-editor-footer.model';
import { CustomerConfigurationState, CustomerProjectDetailsState } from '../customer-editor-state.model';
import { isEqual } from 'lodash';

const nullDateYear = '0001-01-01T00:00:00';

interface UnitsSelectItem {
    value: number;
    text: string;
}

interface DateTimeSelectItem {
    value: string;
    text: string;
}

@Component({
    selector: 'app-edit-customer-editor',
    templateUrl: './edit-customer-editor.component.html',
    styleUrls: ['./edit-customer-editor.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EditCustomerEditorComponent implements OnInit, OnDestroy {
    public showUpdateCustomerEditor: boolean;
    public showNewCustomerEditor: boolean;
    public customers: UsersDetailInfo[];
    public customer: Customer;
    public pageIndex: number;
    public isValidCustomerName: boolean;
    public isCustomerNameErrorDisplay: boolean;
    public customerNameHeader: string;
    public isValidCustomerShortName: boolean;
    public customerName: string;
    public shortName: string;
    public flowViewFlag: boolean;
    public featureChange: boolean;
    public rainfallProfileChange: boolean;
    public usersChange: boolean;
    public units: number;
    public customerID: number;
    public dataTTL = 12;
    public isActive: boolean;
    public unitsofMeasure: UnitsSelectItem[];
    public dateFormatType: DateTimeSelectItem[];
    public timeFormatType: DateTimeSelectItem[];
    public timeZoneType: Array<DateTimeSelectItem & { utcValue: string; }>;
    public dateFormat: string;
    public timeFormat: string;
    public workOrderLink: string;
    public idleTimeOut: number;
    public timeZone: string;
    public daylightSavingFlag: boolean;
    public headerName = 'CUSTOMER EDITOR';
    public uuid: UUID;
    public pagedItems = new Array<Customer>();
    public setFirstPage: boolean;
    public showPagination = true;
    public apiError: string;
    private subscriptions = new Array<Subscription>();
    public showNewLocationEditor: boolean;
    public disableAddLocationBtn: boolean;
    public customerNameLengthIsInvalid: boolean;
    public customerShortNameLengthIsInvalid: boolean;
    public customersLoadingState: boolean;
    public customerEditorDisplayedColumns = ['customerName', 'editDeleteCustomerEditor'];
    public customerEditorFilterColumns = ['customerName'];
    public customerEditorDataSource: FilterDataSource<UsersDetailInfo> | null;
    @ViewChild(MatPaginator) public customerEditorPaginator: MatPaginator;
    @ViewChild(MatSort) public customerEditorSort: MatSort;
    public customerEditorDataChange: BehaviorSubject<UsersDetailInfo[]> = new BehaviorSubject([]);
    public userRole: boolean;
    public get customerEditorData(): UsersDetailInfo[] {
        return this.customerEditorDataChange.value;
    }
    public totalPaginationLength: number;
    public customerStatus: boolean;
    public metricValue = 3;
    /**
     * Reg Ex. Pattern for alpha numeric with -, _ and at least 2 letters and first character must be a letter or number
     */
    public customerNamePattern = REGEX_CONFIG.customerNamePattern;

    /**
     * Reg Ex. Pattern for alpha numeric without space
     */
    public alphaNumericWithoutSpacePattern = REGEX_CONFIG.alphaNumericWithoutSpacePattern;
    public noLeadingWhitespaces = REGEX_CONFIG.noLeadingWhitespaces;

    /**
     * Reg Ex. Pattern for alpha numeric without space
     */
    public numeric3_36Pattern = REGEX_CONFIG.numeric3_36Pattern;

    /**
     * Reg Ex. Pattern for alpha numeric without space
     */
    public numericWith5DecimalPlaces = REGEX_CONFIG.numericWith5DecimalPlaces;
    /**
     * Reprsents customer search input
     */
    public searchString = new FormControl();

    /**
     * Represents saved list of customers
     */
    public initialCustomersData = new Array<UsersDetailInfo>();

    /**
     * Represents the last edited customer
     */
    public selectedCustomerID: number;

    public isApiKeyEnabled: boolean;

    public isCustomAlarmingEnabled: boolean;

    public isCustomAlaramRainGaugesAvailable: boolean;

    public startPage: number;
    public pageSize: number;
    public searchValue: string;
    private sortValue: string;
    private sortDirection: string;
    public dismissText: string;
    public customerEditorHeader: string;
    public addCustomerHeader: string;
    public customerUpdateSuccess: string;
    public customerUpdateErr: string;
    public customerCreateErr: string;
    public customerText: string;
    public archiveDialogTitle: string;
    public archieveDialogMsgStart: string;
    public archieveDialogMsgEnd: string;
    public successfullyText: string;
    public createdMsg: string;
    public updatedMsg: string;
    public archiveBtn: string;
    public cancelBtn: string;
    public archivedSuccessMsg: string;
    public editCustomerHeader: string;
    public sliicerPagepermission: boolean;
    public isAssignUserVisible: boolean;
    public hasSliicerEnabled: boolean;
    public isMonitorCanAddEdit: boolean;
    public tabIndex = 0;
    public redirectUser: boolean;

    public roughness: number = CALCULATION_TYPE_DEFAULTS.DEFAULT_MANNING_ROUGHNESS;

    public usersSelectable: Array<AutoCompleteItem>;

    //GIS
    public gisServiceId: number;
    public servicelist: [{ id: number; name: string; service: string }];
    public contractNumber: string;
    public subscriptionLevel: number;
    public originalContractStart: Date;
    public currentContractStart: Date;
    public currentContractEnd: Date;
    public originalNamesAutoComplete = {
        dataAnalyst: null,
        regionalManager: null,
        salesPerson: null,
        projectManager: null
    }
    public originalSubscriptionLevel: number;
    public dataAnalyst: AutoCompleteItem;
    public regionalManager: AutoCompleteItem;
    public salesPerson: AutoCompleteItem;
    public projectManager: AutoCompleteItem;
    public markedInactiveOn: Date;
    public subscriptionLevelAlternatives = SUBSCRIPTION_LEVELS;
    public customerDateFormat: string;
    public users: string[] = [];
    /** #39310 Whenever auto complete fields was NOT modified */
    public autoCompleteModified = false;
    public fieldsModified = false;
    public additionalFeaturesList: ProjectDetailsAdditionalFeature[];
    public SubscriptionLevel = SubscriptionLevel;

    @ViewChild('addCustomerForm') public customerForm: NgForm;
    @ViewChild(CustomerDetailFeatureComponent) public customerDetailFeatureComponent?: CustomerDetailFeatureComponent;
    @ViewChild(CustomerDetailUserEditorComponent) public customerDetailUserEditorComponent?: CustomerDetailUserEditorComponent;
    @ViewChild(CustomerRainProfileComponent) public customerRainProfileComponent?: CustomerRainProfileComponent;
    @ViewChild(ApiKeyDashboardComponent) public apiKeyDashboardComponent?: ApiKeyDashboardComponent;
    @ViewChild(CustomerDetailLocationsEditorComponent) public customerDetailLocationsEditorComponent?: CustomerDetailLocationsEditorComponent;
    @ViewChild(AdsPrismGISLayersComponent) public adsPrismGISLayersComponent?: AdsPrismGISLayersComponent;
    @ViewChild(AdsPrismFtpSweepComponent) public adsPrismFtpSweepComponent?: AdsPrismFtpSweepComponent;

    public activeTabId = CustomerEditorTabId.Details;
    public activePaginationState?: CustomerEditorPaginationState;
    public CustomerEditorTabId = CustomerEditorTabId;
    private paginationStates = new Map<CustomerEditorTabId, CustomerEditorPaginationState>([
        [CustomerEditorTabId.ApiAllocation, { length: 0, pageIndex: 0, pageSize: 10, pageSizeOptions: [10, 25, 100] }],
        [CustomerEditorTabId.AssignUsers, { length: 0, pageIndex: 0, pageSize: 25, pageSizeOptions: [10, 25, 100] }],
        [CustomerEditorTabId.Locations, { length: 0, pageIndex: 0, pageSize: 10, pageSizeOptions: [10, 25, 100] }],
        [CustomerEditorTabId.FtpSweep, { length: 0, pageIndex: 0, pageSize: 10, pageSizeOptions: [10, 25, 100] }],
    ]);
    private savedCustomerConfiguration?: CustomerConfigurationState;
    private savedCustomerProjectDetails?: CustomerProjectDetailsState;

    public trackByValue = TrackBy.byValue();

    constructor(
        private domOperationUtilsService: DomOperationUtilsService,
        private customerService: CustomerService,
        private snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef,
        private usersService: UsersService,
        private dialog: MatDialog,
        private locationDashboardSvc: LocationDashboardService,
        private dateutilService: DateutilService,
        private statusCodeService: StatusCodeService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private uiUtilsService: UiUtilsService,
        private translate: TranslateService,
        private mapService: MapService,
        private gisService: GISService,
        private locationCardService: LocationCardService
    ) {
        /*  Search by user email address changes  */
        const searchStrgSubscription = this.searchString.valueChanges
            .pipe(debounceTime(400))
            .pipe(distinctUntilChanged())
            .subscribe((res: string) => {
                this.filterCustomers(res);
            });
        this.subscriptions.push(searchStrgSubscription);
        this.hasSliicerEnabled = environment.enableSliicer || false;
    }

    public ngOnInit() {
        this.translate.get('COMMON.DISMISS_TEXT').subscribe((res: string) => {
            this.dismissText = res;
        });
        this.translate.get('CUSTOMER_EDITOR.CUSTOMER_EDITOR_HEADING').subscribe((res: string) => {
            this.customerEditorHeader = res;
            this.headerName = res;
        });
        this.translate.get('CUSTOMER_EDITOR.ADD_CUSTOMER_HEADING').subscribe((res: string) => {
            this.addCustomerHeader = res;
        });
        this.translate.get('CUSTOMER_EDITOR.CUSTOMER_UPDATE_SUCCESS').subscribe((res: string) => {
            this.customerUpdateSuccess = res;
        });
        this.translate.get('CUSTOMER_EDITOR.CUSTOMER_UPDATE_ERR').subscribe((res: string) => {
            this.customerUpdateErr = res;
        });
        this.translate.get('CUSTOMER_EDITOR.CUSTOMER_CREATE_ERR').subscribe((res: string) => {
            this.customerCreateErr = res;
        });
        this.translate.get('COMMON.CUSTOMER_TEXT').subscribe((res: string) => {
            this.customerText = res;
        });
        this.translate.get('CUSTOMER_EDITOR.ARCHIVE_DIALOG_TITLE').subscribe((res: string) => {
            this.archiveDialogTitle = res;
        });
        this.translate.get('CUSTOMER_EDITOR.ARCHIVE_DIALOG_MSG_START').subscribe((res: string) => {
            this.archieveDialogMsgStart = res;
        });
        this.translate.get('CUSTOMER_EDITOR.ARCHIVE_DIALOG_MSG_END').subscribe((res: string) => {
            this.archieveDialogMsgEnd = res;
        });
        this.translate.get('COMMON.SUCCESSFULLY_TEXT').subscribe((res: string) => {
            this.successfullyText = res;
        });
        this.translate.get('COMMON.CREATED_TEXT').subscribe((res: string) => {
            this.createdMsg = res;
        });
        this.translate.get('COMMON.UPDATED_TEXT').subscribe((res: string) => {
            this.updatedMsg = res;
        });
        this.translate.get('COMMON.ARCHIVE_BTN').subscribe((res: string) => {
            this.archiveBtn = res;
        });
        this.translate.get('COMMON.CANCEL_BUTTON').subscribe((res: string) => {
            this.cancelBtn = res;
        });
        this.translate.get('CUSTOMER_EDITOR.ARCHIVED_SUCCESS').subscribe((res: string) => {
            this.archivedSuccessMsg = res;
        });
        this.translate.get('CUSTOMER_EDITOR.EDIT_CUSTOMER_HEADING').subscribe((res: string) => {
            this.editCustomerHeader = res;
        });
        this.subscriptions.push(
            this.usersService.isMonitorEditor.subscribe((response) => {
                this.isMonitorCanAddEdit = response;
            }),
        );
        this.statusCodeService.customerStatus.subscribe((customerStatus: boolean) => {
            this.customerStatus = customerStatus;
        });
        this.statusCodeService.editedCustomerData.subscribe((custmerResponse: GetCustomerSummary) => {
            this.customerNameHeader = custmerResponse.name;
        });
        this.customersLoadingState = true;
        this.isApiKeyEnabled = false;
        this.isCustomAlarmingEnabled = false;
        this.isCustomAlaramRainGaugesAvailable = false;
        this.activatedRoute.queryParamMap.subscribe((params: ParamMap) => {
            this.searchValue = params.get(userSearchParam);
            this.pageIndex = Number(params.get(userSearchPageIndexParam));
            this.pageSize = Number(params.get(userSearchPageSizeParam));
            if(params.has(sortValueParam)) {
                this.sortValue = params.get(sortValueParam);
                this.sortDirection = params.get(sortDirectionParam);
            }
        });
        this.tabIndex = this.statusCodeService.directUser ? 3 : 0;
        this.activeTabId = this.getTabId(this.tabIndex);
        this.activePaginationState = this.paginationStates.get(this.activeTabId);
        this.domOperationUtilsService.editCustomerTabIndex.next(this.tabIndex);
        // Subscribing to the isCustomAlarmsEnabled flag for no raingauges found
        const customAlarmsSubscription = this.statusCodeService.isCustomAlarmEnabled.subscribe((response: boolean) => {
            this.manageCustomAlarmsTab(response);
        });
        this.subscriptions.push(customAlarmsSubscription);

        // Subscribing to the result value from permission API

        const userInfoSubscription = this.statusCodeService.userInfo.subscribe(
            (result: UsersInfo) => {
                if (result.features) {
                    const canAccessCustomerEditor = result.features.some((feature) => feature.id === FEATURE_IDS.CUSTOMER_EDITOR);
                    if (!canAccessCustomerEditor) {
                        this.router.navigate(['/dashboard'], {
                            relativeTo: this.activatedRoute,
                        });
                        return;
                    }
                }

                if (result.customers) {
                    this.customers = result.customers.map((x) => x.customer) as UsersDetailInfo[];
                }

                if (result.userRole) {
                    this.userRole = result.userRole.toString() === USER_ROLES.ADMIN;
                    this.isAssignUserVisible =
                        result.userRole.toString() === USER_ROLES.ADMIN || result.userRole.toString() === USER_ROLES.CUSTOMER_ADMIN;
                } else {
                    this.userRole = false;
                }

                if(result?.userRole?.toString() === USER_ROLES.CUSTOMER_ADMIN && !this.userRole){
                    const featuresSubscription = this.usersService.getAllFeatures().subscribe((features: Array<IFeatures>) => {
                        this.userRole = features?.some((x) => !x.canassigncustomer && x.id === FEATURE_IDS.CUSTOMER_EDITOR);
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        this.subscriptions.push(featuresSubscription);
                    });
                }

                this.initialCustomersData = this.customers;

                this.generateCustomerEditorTable();
                if (this.searchString.value !== '') {
                    this.filterCustomers(this.searchString.value);
                }
                this.customersLoadingState = false;
            },
            () => {
                this.customersLoadingState = false;
            },
        );
        this.subscriptions.push(userInfoSubscription);
        this.unitsofMeasure = [
            { value: 1, text: 'US Standard CFS' },
            { value: 3, text: 'US Standard MGD' },
            { value: 2, text: 'Metric' },
        ];
        this.dateFormatType = [
            { value: 'MM/DD/YYYY', text: 'MM/DD/YYYY' },
            { value: 'DD/MM/YYYY', text: 'DD/MM/YYYY' },
            { value: 'YYYY/MM/DD', text: 'YYYY/MM/DD' },
        ];
        this.timeFormatType = [
            { value: 'h:mm:ss tt', text: '12 hours' },
            { value: 'hh:mm:ss', text: '24 hours' },
        ];
        const timeZoneSubscription = this.customerService.getTimeZone().subscribe((res) => {
            this.timeZoneType = res;
        });
        this.subscriptions.push(timeZoneSubscription);

        this.showNewLocationEditor = false;
        this.generateCustomerEditorTable();
        this.statusCodeService.directUser = false;

        // Called when user edits customer on customer editor screen.
        this.subscriptions.push(this.statusCodeService.customerIdEdited.pipe(distinctUntilChanged()).subscribe((customerID: number) => {
            if (customerID > 0) {
                this.getCustomerPermission(customerID);
            }
        }));
        // get current query params for customer
        const currentCustomerID = Number(this.activatedRoute.snapshot.queryParamMap.get(customerEditorQueryParam));

        this.updateCustomer(currentCustomerID);
        if (this.customerID > 0) {
            this.usersService.isSliicerAllowed.subscribe((isAllowed) => {
                this.sliicerPagepermission = isAllowed.value;
            });
        }
        this.setUnit();
        this.servicelist = [{ id: 1, name: 'WFS', service: 'https://geo-dev.adsprism.net/geoserver/WFS' }];

        this.dateutilService.dateFormat.subscribe(() => {
            this.customerDateFormat = this.dateutilService.getFormat();
        });

        if (currentCustomerID) {
            this.customersLoadingState = true;
            const assignedUsersSubscription: Subscription = this.usersService
                .getAssignedUsersByCustomer(currentCustomerID)
                .subscribe(
                    (response: GetUsersResponse) => {
                        if (response && response.payload && response.payload.length > 0) {
                            this.users = response.payload
                                .filter((user) => user.isActive)
                                .map((user) => `${user.firstName}  ${user.lastName}  (${user.userName})`)
                                .filter((user) => StringUtils.removeWhitespace(user).length)
                                .sort(StringUtils.caseInsensitiveSort);
                            this.usersSelectable = this.users.map(u => {return {name: u}});
                        } else {
                            this.users = [];
                            this.usersSelectable = [];
                        }

                        this.customersLoadingState = false;
                    },
                    () => {},
                );
            this.subscriptions.push(assignedUsersSubscription);
        }

    }

    public ngOnDestroy() {
        if (this.mapService.addEditLocationDialog) {
            this.mapService.addEditLocationDialog.close();
            this.mapService.addEditLocationDialog = null;
        }
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public scrollTop() {
        this.domOperationUtilsService.scrollToTop('#customerGroupEditorTable');
    }

    public onPaginateChange() {
        this.scrollTop();
    }

    public openCreateCustomerEditor() {
        this.scrollTop();
        this.headerName = this.addCustomerHeader;
        this.showNewCustomerEditor = true;
        this.showUpdateCustomerEditor = false;
        this.resetCustomerForm();
    }

    /**
     * Method takes a sting as an argument and filters out customers whose names include the string
     * @param searchString - string to search for customer
     */
    public filterCustomers(searchString: string) {
        if (!searchString || searchString.trim() === '') {
            this.customers = this.initialCustomersData;
        } else {
            searchString = searchString.trim();
            this.customers = this.initialCustomersData.filter((x) =>
                x.customerName.toLowerCase().includes(searchString.toLowerCase()),
            );
            this.customerEditorPaginator.pageIndex = 0;
        }
        this.generateCustomerEditorTable();
    }

    public showCustomerPageRecords(pagedItems: Customer[]) {
        this.pagedItems = pagedItems;
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    public featureselected(featureclick: boolean) {
        this.featureChange = featureclick;
    }

    public rainfallProfileChanged(rainfallProfileSelected: boolean) {
        this.rainfallProfileChange = rainfallProfileSelected;
    }

    public usersSelected(usersSelected: boolean) {
        this.usersChange = usersSelected;
    }


    public validateDuplicateCustomerName() {
        this.customerName = this.customerName.trim();
        this.customerName = StringUtils.capitalizedStringWithSpace(this.customerName);
        this.customerNameLengthIsInvalid = this.customerName.length < 6;
        if (this.customerName !== null) {
            if (this.customers.find((x) => x.customerName.toLowerCase() === this.customerName.toLowerCase())) {
                if (this.showUpdateCustomerEditor && this.customer.customerName === this.customerName) {
                    this.isValidCustomerName = true;
                } else {
                    this.isValidCustomerName = false;
                }
            } else {
                this.customerName = this.customerName.charAt(0).toUpperCase() + this.customerName.slice(1);
                this.isValidCustomerName = true;
            }
        }
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    public validateShortDuplicateCustomerName() {
        this.shortName = this.shortName.trim();
        this.customerShortNameLengthIsInvalid = this.shortName.length < 3;
        if (this.customers.find((x) => x.shortName && x.shortName.toLowerCase() === this.shortName.toLowerCase())) {
            this.isValidCustomerShortName = false;
        } else {
            this.isValidCustomerShortName = true;
        }
    }

    public addCustomer() {
        if(this.isSubscirpitionLevelChange()) {
            this.dialogConfirmSubscriptionLevel().subscribe((btn) => {
                if(btn.whichButtonWasPressed === ConfirmationButton.ok) {
                    this.apiSendCustomer();
                }
            })
        } else {
            this.apiSendCustomer();
        }
    }

    public onSaveAdditionalFeatures(features: ProjectDetailsAdditionalFeature[]) {
        this.additionalFeaturesList = features;
        this.customersLoadingState = true;
        const subscription = this.apiUpdateProjectDetails()
            .pipe(finalize(() => {
                this.customersLoadingState = false;
                this.uiUtilsService.safeChangeDetection(this.cdr);
            }))
            .subscribe({
                next: () => {
                    this.featureChange = false;
                    this.customerDetailFeatureComponent?.markSaved();
                    this.snackBar.open(StringUtils.joinWithSingleSpace(this.customerName, this.customerUpdateSuccess), this.dismissText, {
                        duration: 10000,
                    });
                    this.statusCodeService.customerIdInEditScreen.next(this.customerID);
                    this.statusCodeService.customerIdInEditName.next(this.customerName);
                },
                error: (error: unknown) => {
                    this.apiError = this.getApiErrorMessage(error);
                    this.snackBar.open(this.apiError, this.dismissText, {
                        panelClass: 'custom-error-snack-bar',
                    });
                }
            });
        this.subscriptions.push(subscription);
    }

    public apiUpdateProjectDetails(): Observable<void> {
        return this.customerService
            .updateProjectDetails(this.customer.customerID, {
                contractNumber: this.contractNumber,
                currentContractEnd: this.currentContractEnd,
                currentContractStart: this.currentContractStart,
                dataAnalyst: this.dataAnalyst?.name,
                markedInactiveOn: this.markedInactiveOn,
                originalContractStart: this.originalContractStart,
                projectManager: this.projectManager?.name,
                regionalManager: this.regionalManager?.name,
                salesPerson: this.salesPerson?.name,
                subscriptionLevel: this.subscriptionLevel,
                additionalFeaturesList: this.subscriptionLevel === SubscriptionLevel.PrismLimited ? [] : this.additionalFeaturesList,
            })
            .pipe(
                tap(() => {
                    this.originalNamesAutoComplete.dataAnalyst = this.dataAnalyst?.name;
                    this.originalNamesAutoComplete.projectManager = this.projectManager?.name;
                    this.originalNamesAutoComplete.regionalManager = this.regionalManager?.name;
                    this.originalNamesAutoComplete.salesPerson = this.salesPerson?.name;

                    this.originalSubscriptionLevel = this.subscriptionLevel;
                    this.savedCustomerProjectDetails = this.getCurrentCustomerProjectDetails();
                    if (this.featureChange) {
                        this.featureChange = false;
                        this.customerDetailFeatureComponent?.markSaved();
                    }
                }));
    }

    public saveCustomerEditor(closeAfterSave: boolean): void {
        if (!this.isCustomerEditorFormValid()) {
            this.markCustomerFormTouched();
            return;
        }

        if (!this.hasUnsavedChanges()) {
            if (closeAfterSave) {
                this.doExitCustomerEditor();
            }
            return;
        }

        const subscription = this.confirmSaveIfNeeded()
            .pipe(
                switchMap((canSave: boolean) => {
                    if (!canSave) {
                        return of(false);
                    }

                    this.customersLoadingState = true;
                    return this.savePendingCustomerEditorChanges();
                }),
                finalize(() => {
                    this.customersLoadingState = false;
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                }),
            )
            .subscribe({
                next: (saved: boolean) => {
                    if (!saved) {
                        return;
                    }

                    this.resetUnsavedState();
                    this.customerNameHeader = this.customerName;
                    this.snackBar.open(StringUtils.joinWithSingleSpace(this.customerName, this.customerUpdateSuccess), this.dismissText, {
                        duration: 10000,
                    });
                    this.statusCodeService.customerIdInEditScreen.next(this.customerID);
                    this.statusCodeService.customerIdInEditName.next(this.customerName);

                    if (closeAfterSave) {
                        this.doExitCustomerEditor();
                    }
                },
                error: (error: unknown) => {
                    this.apiError = this.getApiErrorMessage(error);
                    this.snackBar.open(this.apiError, this.dismissText, {
                        panelClass: 'custom-error-snack-bar',
                    });
                }
            });

        this.subscriptions.push(subscription);
    }

    public hasUnsavedChanges(): boolean {
        return this.hasCustomerDetailsChanges()
            || this.featureChange
            || this.usersChange
            || this.rainfallProfileChange
            || !!this.customerDetailUserEditorComponent?.hasPendingChanges()
            || !!this.customerRainProfileComponent?.hasPendingChanges();
    }

    public canSaveCustomerEditor(): boolean {
        return this.hasUnsavedChanges() && this.isCustomerEditorFormValid() && !this.customersLoadingState;
    }

    public canSaveAndCloseCustomerEditor(): boolean {
        return this.canSaveCustomerEditor();
    }

    public canNavigateToPreviousTab(): boolean {
        const enabledIndexes = this.getEnabledTabIndexes();
        return enabledIndexes.indexOf(this.tabIndex) > 0;
    }

    public canNavigateToNextTab(): boolean {
        const enabledIndexes = this.getEnabledTabIndexes();
        const currentEnabledIndex = enabledIndexes.indexOf(this.tabIndex);
        return currentEnabledIndex > -1 && currentEnabledIndex < enabledIndexes.length - 1;
    }

    public goToPreviousTab(tabGroup: MatTabGroup): void {
        this.goToTabShortcut(tabGroup, -1);
    }

    public goToNextTab(tabGroup: MatTabGroup): void {
        this.goToTabShortcut(tabGroup, 1);
    }

    public paginationStateChanged(tabId: CustomerEditorTabId, state: CustomerEditorPaginationState): void {
        this.paginationStates.set(tabId, { ...state });
        if (this.activeTabId === tabId) {
            this.activePaginationState = { ...state };
        }
    }

    public onFooterPage(page: PageEvent): void {
        const state: CustomerEditorPaginationState = {
            length: page.length,
            pageIndex: page.pageIndex,
            pageSize: page.pageSize,
            pageSizeOptions: this.activePaginationState?.pageSizeOptions ?? [10, 25, 100],
        };
        this.paginationStateChanged(this.activeTabId, state);

        switch (this.activeTabId) {
            case CustomerEditorTabId.ApiAllocation:
                this.apiKeyDashboardComponent?.applyPagination(page);
                break;
            case CustomerEditorTabId.AssignUsers:
                this.customerDetailUserEditorComponent?.changePage(page);
                break;
            case CustomerEditorTabId.Locations:
                this.customerDetailLocationsEditorComponent?.applyPagination(page);
                break;
            case CustomerEditorTabId.FtpSweep:
                this.adsPrismFtpSweepComponent?.applyPagination(page);
                break;
        }
    }

    public showLocationAddAction(): boolean {
        return this.activeTabId === CustomerEditorTabId.Details
            || this.activeTabId === CustomerEditorTabId.Locations;
    }

    public showDirectAddAction(): boolean {
        return this.activeTabId === CustomerEditorTabId.ApiAllocation
            || this.activeTabId === CustomerEditorTabId.AssignUsers
            || this.activeTabId === CustomerEditorTabId.Gis
            || this.activeTabId === CustomerEditorTabId.FtpSweep;
    }

    public isAddActionDisabled(): boolean {
        switch (this.activeTabId) {
            case CustomerEditorTabId.ApiAllocation:
                return !!this.apiKeyDashboardComponent?.isLoading;
            case CustomerEditorTabId.AssignUsers:
                return !this.customerDetailUserEditorComponent?.addNewUserVisible
                    || !!this.customerDetailUserEditorComponent?.isLoading;
            case CustomerEditorTabId.Locations:
                return !this.isMonitorCanAddEdit || !!this.customerDetailLocationsEditorComponent?.disableAddLocationBtn;
            case CustomerEditorTabId.Details:
                return !this.isMonitorCanAddEdit || this.disableAddLocationBtn;
            case CustomerEditorTabId.Gis:
                return !!this.adsPrismGISLayersComponent?.isLoading;
            case CustomerEditorTabId.FtpSweep:
                return !!this.adsPrismFtpSweepComponent?.loadingState;
            default:
                return false;
        }
    }

    public getAddActionClass(): string {
        switch (this.activeTabId) {
            case CustomerEditorTabId.ApiAllocation:
                return 'edit-cus-api-add-hint';
            case CustomerEditorTabId.Details:
                return 'edit-cus-details-add-hint';
            case CustomerEditorTabId.AssignUsers:
                return 'edit-cus-users-add-hint';
            case CustomerEditorTabId.Locations:
                return 'edit-cus-locs-add-hint';
            case CustomerEditorTabId.Gis:
                return 'edit-cus-gis-add-hint';
            case CustomerEditorTabId.FtpSweep:
                return 'edit-cus-ftp-add-hint';
            default:
                return '';
        }
    }

    public getAddActionIcon(): string {
        switch (this.activeTabId) {
            case CustomerEditorTabId.Details:
            case CustomerEditorTabId.Locations:
                return 'add_location';
            case CustomerEditorTabId.ApiAllocation:
                return 'vpn_key';
            case CustomerEditorTabId.AssignUsers:
                return 'person_add';
            case CustomerEditorTabId.Gis:
                return 'layers';
            case CustomerEditorTabId.FtpSweep:
                return 'cloud_upload';
            default:
                return 'add';
        }
    }

    public getAddActionTooltipKey(): string {
        switch (this.activeTabId) {
            case CustomerEditorTabId.ApiAllocation:
                return 'ADMIN.API_KEY_DASHBOARD.CREATE_API_KEY';
            case CustomerEditorTabId.AssignUsers:
                return 'COMMON.ADD_NEW_USER';
            case CustomerEditorTabId.Gis:
                return 'CUSTOMER_EDITOR.GIS_ADD_LAYER';
            case CustomerEditorTabId.FtpSweep:
                return 'CUSTOMER_EDITOR.HINTS.FTP.ADD';
            default:
                return 'COMMON.ADD_LOCATION_TEXT';
        }
    }

    public onAddAction(): void {
        switch (this.activeTabId) {
            case CustomerEditorTabId.ApiAllocation:
                this.apiKeyDashboardComponent?.createApiKey();
                break;
            case CustomerEditorTabId.AssignUsers:
                this.customerDetailUserEditorComponent?.setupAdminDetailRoute('');
                break;
            case CustomerEditorTabId.Gis:
                this.adsPrismGISLayersComponent?.addNewGISService();
                break;
            case CustomerEditorTabId.FtpSweep:
                this.adsPrismFtpSweepComponent?.addNewFTPServer();
                break;
        }
    }

    public addCompositeLocationForActiveTab(): void {
        if (!this.isMonitorCanAddEdit) {
            return;
        }

        if (this.activeTabId === CustomerEditorTabId.Locations) {
            this.customerDetailLocationsEditorComponent?.addCompositeLocation();
            return;
        }

        this.addCompositeLocation();
    }

    public addTritonLocationForActiveTab(): void {
        if (!this.isMonitorCanAddEdit) {
            return;
        }

        if (this.activeTabId === CustomerEditorTabId.Locations) {
            this.customerDetailLocationsEditorComponent?.addTritonLocation();
            return;
        }

        this.addTritonLocation();
    }

    public isTabDirty(tabId: CustomerEditorTabId): boolean {
        switch (tabId) {
            case CustomerEditorTabId.Details:
                return this.hasCustomerDetailsChanges();
            case CustomerEditorTabId.AssignFeatures:
                return this.featureChange;
            case CustomerEditorTabId.AssignUsers:
                return !!this.customerDetailUserEditorComponent?.hasPendingChanges();
            case CustomerEditorTabId.RainfallProfile:
                return !!this.customerRainProfileComponent?.hasPendingChanges();
            default:
                return false;
        }
    }

    public isTabInvalid(tabId: CustomerEditorTabId): boolean {
        switch (tabId) {
            case CustomerEditorTabId.Details:
                return this.hasCustomerDetailsChanges()
                    && (!!this.customerForm?.form?.invalid || !this.isValidCustomerName || !this.isValidCustomerShortName);
            case CustomerEditorTabId.RainfallProfile:
                return !!this.customerRainProfileComponent?.hasInvalidPendingChanges();
            default:
                return false;
        }
    }

    public canDeactivate(): Observable<boolean> | boolean {
        if (!this.hasUnsavedChanges()) {
            return true;
        }

        return this.warningDialogOpen().pipe(
            map((data: IComponentDialogConfirmationResult) => data?.whichButtonWasPressed === ConfirmationButton.ok),
        );
    }

    private confirmSaveIfNeeded(): Observable<boolean> {
        if (!this.isSubscirpitionLevelChange()) {
            return of(true);
        }

        return this.dialogConfirmSubscriptionLevel().pipe(
            map((btn: IComponentDialogConfirmationResult) => btn?.whichButtonWasPressed === ConfirmationButton.ok),
        );
    }

    private savePendingCustomerEditorChanges(): Observable<boolean> {
        this.apiError = null;
        this.headerName = this.customerEditorHeader;

        if (this.featureChange && this.customerDetailFeatureComponent) {
            this.additionalFeaturesList = this.customerDetailFeatureComponent.getUpdatedAdditionalFeatures();
        }

        const saveOperations: Array<Observable<boolean>> = [];

        if (this.hasCustomerConfigurationChanges()) {
            saveOperations.push(this.updateCustomerDetails());
        }

        if (this.hasProjectDetailsChanges()) {
            saveOperations.push(this.apiUpdateProjectDetails().pipe(map(() => true)));
        }

        if (this.customerDetailUserEditorComponent?.hasPendingChanges()) {
            saveOperations.push(this.customerDetailUserEditorComponent.savePendingChanges(false));
        }

        if (this.customerRainProfileComponent?.hasPendingChanges()) {
            saveOperations.push(this.customerRainProfileComponent.savePendingChanges(false));
        }

        if (saveOperations.length === 0) {
            return of(true);
        }

        return forkJoin(saveOperations).pipe(
            map((results: boolean[]) => results.every((result: boolean) => result)),
        );
    }

    private updateCustomerDetails(): Observable<boolean> {
        const newCustomer = this.buildCustomerModel();

        return this.customerService.updateCustomer(newCustomer, this.customer.customerID).pipe(
            tap(() => {
                Object.assign(this.customer, newCustomer);
                this.savedCustomerConfiguration = this.getCurrentCustomerConfiguration();
                this.dateutilService.dateFormat.next(newCustomer.dateFormat);
                this.dateutilService.timeFormat.next(newCustomer.timeFormat);
                this.selectedCustomerID = newCustomer.customerID;
            }),
            map(() => true),
        );
    }

    private buildCustomerModel(): Customer {
        const newCustomer = new Customer();
        newCustomer.customerName = this.customerName;
        if (!this.showUpdateCustomerEditor) {
            newCustomer.shortName = this.shortName;
        } else {
            newCustomer.customerID = this.customer.customerID;
            newCustomer.shortName = this.customer.shortName;
        }
        newCustomer.dataTTL = this.dataTTL;
        newCustomer.isActive = this.customerStatus;
        newCustomer.isNewCollect = false;
        newCustomer.collectProcessType = this.flowViewFlag
            ? CollectProcessType.FlowViewAndCore
            : CollectProcessType.Core;
        newCustomer.unitsType = this.units;
        newCustomer.dateFormat = this.dateFormat;
        newCustomer.timeFormat = this.timeFormat;
        newCustomer.timeZone = this.timeZone;
        newCustomer.isDaylightSavings = this.daylightSavingFlag || false;
        newCustomer.workOrderLink = this.workOrderLink;
        newCustomer.idleTimeOut = this.idleTimeOut || IDLE_MESSAGE_MINUTES;
        newCustomer.roughness = this.roughness;

        return newCustomer;
    }

    private hasCustomerDetailsChanges(): boolean {
        return this.hasCustomerConfigurationChanges() || this.hasCustomerProjectDetailsChanges();
    }

    private hasCustomerConfigurationChanges(): boolean {
        return !!this.savedCustomerConfiguration
            && !isEqual(this.savedCustomerConfiguration, this.getCurrentCustomerConfiguration());
    }

    private hasCustomerProjectDetailsChanges(): boolean {
        return !!this.savedCustomerProjectDetails
            && !isEqual(this.savedCustomerProjectDetails, this.getCurrentCustomerProjectDetails());
    }

    private hasProjectDetailsChanges(): boolean {
        return this.hasCustomerProjectDetailsChanges() || this.featureChange;
    }

    private getCurrentCustomerConfiguration(): CustomerConfigurationState {
        return {
            customerName: this.normalizeString(this.customerName),
            shortName: this.normalizeString(this.shortName),
            dataTTL: this.normalizeNumber(this.dataTTL),
            flowViewFlag: !!this.flowViewFlag,
            units: this.normalizeNumber(this.units),
            dateFormat: this.normalizeString(this.dateFormat),
            timeFormat: this.normalizeString(this.timeFormat),
            timeZone: this.normalizeString(this.timeZone),
            daylightSavingFlag: !!this.daylightSavingFlag,
            idleTimeOut: this.normalizeNumber(this.idleTimeOut || IDLE_MESSAGE_MINUTES),
            roughness: this.normalizeNumber(this.roughness),
            customerStatus: !!this.customerStatus,
        };
    }

    private getCurrentCustomerProjectDetails(): CustomerProjectDetailsState {
        return {
            contractNumber: this.normalizeString(this.contractNumber),
            subscriptionLevel: this.normalizeNumber(this.subscriptionLevel),
            originalContractStart: this.normalizeDate(this.originalContractStart),
            currentContractStart: this.normalizeDate(this.currentContractStart),
            currentContractEnd: this.normalizeDate(this.currentContractEnd),
            dataAnalyst: this.normalizeString(this.dataAnalyst?.name),
            regionalManager: this.normalizeString(this.regionalManager?.name),
            salesPerson: this.normalizeString(this.salesPerson?.name),
            projectManager: this.normalizeString(this.projectManager?.name),
        };
    }

    private normalizeString(value?: string | null): string {
        return value ?? '';
    }

    private normalizeNumber(value?: number | string | null): number | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const normalizedValue = Number(value);
        return Number.isNaN(normalizedValue) ? null : normalizedValue;
    }

    private normalizeDate(value?: Date | null): number | null {
        return value instanceof Date && !Number.isNaN(value.getTime()) ? value.getTime() : null;
    }

    private isCustomerEditorFormValid(): boolean {
        const isRainfallProfileValid = !this.customerRainProfileComponent?.hasInvalidPendingChanges();
        if (!this.customerForm?.form) {
            return isRainfallProfileValid;
        }

        return this.customerForm.form.valid
            && this.isValidCustomerName
            && this.isValidCustomerShortName
            && isRainfallProfileValid;
    }

    private markCustomerFormTouched(): void {
        if (!this.customerForm?.form) {
            return;
        }

        Object.keys(this.customerForm.form.controls).forEach((controlName: string) => {
            this.customerForm.form.controls[controlName].markAsTouched();
        });
    }

    private resetUnsavedState(): void {
        this.featureChange = false;
        this.rainfallProfileChange = false;
        this.usersChange = false;
        this.autoCompleteModified = false;
        this.fieldsModified = false;
        this.customerForm?.form?.markAsPristine();
        this.customerDetailFeatureComponent?.markSaved();
    }

    private getTabId(tabIndex: number): CustomerEditorTabId {
        switch (tabIndex) {
            case 0:
                return CustomerEditorTabId.Details;
            case 1:
                return CustomerEditorTabId.ApiAllocation;
            case 2:
                return CustomerEditorTabId.AssignFeatures;
            case 3:
                return CustomerEditorTabId.AssignUsers;
            case 4:
                return CustomerEditorTabId.Locations;
            case 5:
                return this.hasSliicerEnabled ? CustomerEditorTabId.RainfallProfile : CustomerEditorTabId.FtpSweep;
            case 6:
                return CustomerEditorTabId.Gis;
            case 7:
                return CustomerEditorTabId.FtpSweep;
            default:
                return CustomerEditorTabId.Details;
        }
    }

    private getEnabledTabIndexes(): number[] {
        const tabIndexes = [0];

        if (this.isApiKeyEnabled) {
            tabIndexes.push(1);
        }

        if (this.userRole) {
            tabIndexes.push(2);
        }

        if (this.isAssignUserVisible) {
            tabIndexes.push(3);
        }

        tabIndexes.push(4);

        if (this.hasSliicerEnabled) {
            tabIndexes.push(5, 6, 7);
        } else {
            tabIndexes.push(5);
        }

        return tabIndexes;
    }

    private goToTabShortcut(tabGroup: MatTabGroup, direction: number): void {
        const enabledIndexes = this.getEnabledTabIndexes();
        const selectedIndex = tabGroup.selectedIndex ?? this.tabIndex;
        const currentEnabledIndex = enabledIndexes.indexOf(selectedIndex);

        if (currentEnabledIndex === -1) {
            return;
        }

        const nextEnabledIndex = currentEnabledIndex + direction;
        if (nextEnabledIndex < 0 || nextEnabledIndex >= enabledIndexes.length) {
            return;
        }

        this.tabIndex = enabledIndexes[nextEnabledIndex];
        tabGroup.selectedIndex = this.tabIndex;
        this.domOperationUtilsService.currentScreenNo = this.tabIndex;
        this.domOperationUtilsService.editCustomerTabIndex.next(this.tabIndex);
    }

    private getApiErrorMessage(error: unknown): string {
        if (typeof error === 'object' && error !== null && '_body' in error) {
            const responseError = error as { _body?: unknown };
            if (typeof responseError._body === 'string') {
                return responseError._body;
            }
        }

        if (typeof error === 'object' && error !== null && 'message' in error) {
            const responseError = error as { message?: unknown };
            if (typeof responseError.message === 'string') {
                return responseError.message;
            }
        }

        return this.customerUpdateErr;
    }

    public apiSendCustomer() {
        this.statusCodeService.customerIdInEditName.next(this.customerName);
        this.statusCodeService.customerIdInEditScreen.next(this.customerID);
        this.apiError = null;
        this.customersLoadingState = true;
        this.headerName = this.customerEditorHeader;
        const newCustomer = new Customer();
        newCustomer.customerName = this.customerName;
        if (!this.showUpdateCustomerEditor) {
            newCustomer.shortName = this.shortName;
        } else {
            newCustomer.customerID = this.customer.customerID;
            newCustomer.shortName = this.customer.shortName;
        }
        newCustomer.dataTTL = this.dataTTL;
        newCustomer.isActive = this.customerStatus;
        newCustomer.isNewCollect = false;
        newCustomer.collectProcessType = this.flowViewFlag
            ? CollectProcessType.FlowViewAndCore
            : CollectProcessType.Core;
        newCustomer.unitsType = this.units;
        newCustomer.dateFormat = this.dateFormat;
        newCustomer.timeFormat = this.timeFormat;
        newCustomer.timeZone = this.timeZone;
        newCustomer.isDaylightSavings = this.daylightSavingFlag || false;
        newCustomer.workOrderLink = this.workOrderLink;
        newCustomer.idleTimeOut = this.idleTimeOut || IDLE_MESSAGE_MINUTES;
        newCustomer.roughness = this.roughness;

        let message = null;

        if (this.showUpdateCustomerEditor) {
            message = this.updatedMsg;
            const subscription = this.customerService.updateCustomer(newCustomer, this.customer.customerID).subscribe(
                () => {
                    this.customersLoadingState = false;
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    // display toast message on successfully customer updation
                    this.snackBar.open(StringUtils.joinWithSingleSpace(this.customerName, this.customerUpdateSuccess), this.dismissText, {
                        duration: 10000,
                    });
                    this.doExitCustomerEditor();
                    this.dateutilService.dateFormat.next(newCustomer.dateFormat);
                    this.dateutilService.timeFormat.next(newCustomer.timeFormat);
                    this.selectedCustomerID = newCustomer.customerID;
                },
                (error) => {
                    this.customersLoadingState = false;
                    this.apiError = error._body;
                    this.snackBar.open(this.apiError, this.dismissText, {
                        panelClass: 'custom-error-snack-bar',
                    });
                },
            );
            this.subscriptions.push(subscription);
            this.apiUpdateProjectDetails().subscribe(() => {});
        } else {
            message = this.createdMsg;

            const addCustomerSubscription = this.customerService.addCustomer(newCustomer).subscribe(
                (response) => {
                    this.customersLoadingState = false;
                    if (response.customerID > 0) {
                        this.customer = response;
                        const snackbarRef: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(
                            StringUtils.joinWithSingleSpace(this.customerName, this.customerText, message, this.successfullyText),
                            this.dismissText,
                        );
                        setTimeout(snackbarRef.dismiss.bind(snackbarRef), 10000);
                        this.showNewCustomerEditor = false;
                        this.selectedCustomerID = response.customerID;
                        this.customerEditorPaginator.pageIndex = 0;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        this.searchString.setValue('');
                        const sub = this.customerService
                            .updateProjectDetails(response.customerID, {
                                contractNumber: this.contractNumber,
                                currentContractEnd: this.dateutilService.getLocalDateFromUTCDate(
                                    this.currentContractEnd,
                                ),
                                currentContractStart: this.dateutilService.getLocalDateFromUTCDate(
                                    this.currentContractStart,
                                ),
                                dataAnalyst: this.dataAnalyst?.name,
                                markedInactiveOn: this.markedInactiveOn,
                                originalContractStart: this.dateutilService.getLocalDateFromUTCDate(
                                    this.originalContractStart,
                                ),
                                projectManager: this.projectManager?.name,
                                regionalManager: this.regionalManager?.name,
                                salesPerson: this.salesPerson?.name,
                                subscriptionLevel: this.subscriptionLevel,
                            })
                            .subscribe(() => {
                                this.originalNamesAutoComplete.dataAnalyst = this.dataAnalyst?.name
                                this.originalNamesAutoComplete.projectManager = this.projectManager?.name
                                this.originalNamesAutoComplete.regionalManager = this.regionalManager?.name
                                this.originalNamesAutoComplete.salesPerson = this.salesPerson?.name

                                this.originalSubscriptionLevel = this.subscriptionLevel;
                            });

                        this.subscriptions.push(sub);
                    } else {
                        this.snackBar.open(`${StringUtils.joinWithSingleSpace(this.customerCreateErr, this.customerName)}.`, this.dismissText, {
                            panelClass: 'custom-error-snack-bar',
                        });
                    }
                },
                (error) => {
                    this.apiError = error._body;
                    this.snackBar.open(this.apiError, this.dismissText, {
                        panelClass: 'custom-error-snack-bar',
                    });
                    this.customersLoadingState = false;
                },
            );

            this.subscriptions.push(addCustomerSubscription);
        }
    }

    public emitCustomerEditor() {
        this.searchString.setValue('');
    }

    private checkRequiredFields() {
        for (const controlName in this.customerForm.form.controls) {
            if (this.customerForm.form.controls.hasOwnProperty(controlName)) {
              const control = this.customerForm.form.controls[controlName];
              if (control.errors && control.errors.required) {
                control.markAsTouched();
              }
            }
        }
    }

    private updateCustomer(customerId: number) {
        this.customersLoadingState = true;
        // set customer id for editing
        this.statusCodeService.customerIdEdited.next(customerId);
        this.selectedCustomerID = customerId;
        this.customerID = customerId;
        this.openCreateCustomerEditor();
        this.showUpdateCustomerEditor = true;
        this.scrollTop();
        this.headerName = this.editCustomerHeader;
        const getCustomerByIdSubscription = this.customerService.getCustomerById(customerId).subscribe((res) => {
            this.customersLoadingState = false;
            this.customer = res;
            // #46401 Update Customer status
            this.statusCodeService.customerStatus.next(res.isActive);
            this.customerName = this.customer.customerName;
            this.shortName = this.customer.shortName;
            this.customerID = this.customer.customerID;
            this.dataTTL = this.customer.dataTTL;
            this.isActive = this.customer.isActive;
            this.flowViewFlag = this.customer.collectProcessType === CollectProcessType.FlowViewAndCore;
            const findUnitType = this.unitsofMeasure.find((x) => Number(x.value) === Number(this.customer.unitsType));
            if (!findUnitType) {
                this.units = this.unitsofMeasure[0].value;
            } else {
                this.units = findUnitType.value;
            }
            // checking units are metric or non metric
            const isMetric = this.units && Number(this.units) === UnitOfMeasureType.METRIC;
            this.customerService.isUnitTypeMetric.next(isMetric);

            this.dateFormat = this.customer.dateFormat;
            this.timeFormat = this.customer.timeFormat;
            this.timeZone = this.customer.timeZone;
            this.workOrderLink = this.customer.workOrderLink ? this.customer.workOrderLink : environment.workOrderLink;
            this.idleTimeOut = this.customer.idleTimeOut || IDLE_MESSAGE_MINUTES;
            this.daylightSavingFlag = this.customer.isDaylightSavings;
            this.isValidCustomerName = true;
            this.isValidCustomerShortName = true;
            this.roughness = res.roughness.toString() ? res.roughness : CALCULATION_TYPE_DEFAULTS.DEFAULT_MANNING_ROUGHNESS;
            this.savedCustomerConfiguration = this.getCurrentCustomerConfiguration();
            this.customerForm?.form?.markAsPristine();
        });
        this.subscriptions.push(getCustomerByIdSubscription);

        const getProjectDetailsSubscription = this.customerService.getProjectDetails(customerId).subscribe(
            (res) => {
                this.contractNumber = res.contractNumber;
                this.subscriptionLevel = res.subscriptionLevel;
                this.originalContractStart =
                    res.originalContractStart && res.originalContractStart !== nullDateYear
                        ? new Date(res.originalContractStart)
                        : null;
                this.currentContractStart =
                    res.currentContractStart && res.currentContractStart !== nullDateYear
                        ? new Date(res.currentContractStart)
                        : null;
                this.currentContractEnd =
                    res.currentContractEnd && res.currentContractEnd !== nullDateYear
                        ? new Date(res.currentContractEnd)
                        : null;
                if(res.dataAnalyst) {
                    this.dataAnalyst = {name: res.dataAnalyst};
                } else {
                    this.dataAnalyst = undefined;
                }
                if(res.projectManager) {
                    this.projectManager = {name: res.projectManager};
                } else {
                    this.projectManager = undefined;
                }
                if(res.regionalManager) {
                    this.regionalManager = {name: res.regionalManager};
                } else {
                    this.regionalManager = undefined;
                }
                if(res.salesPerson) {
                    this.salesPerson = {name: res.salesPerson};
                } else {
                    this.salesPerson = undefined;
                }

                this.additionalFeaturesList = res?.additionalFeaturesList ?? [];

                this.originalNamesAutoComplete.dataAnalyst = res.dataAnalyst;
                this.originalNamesAutoComplete.projectManager = res.projectManager;
                this.originalNamesAutoComplete.regionalManager = res.regionalManager;
                this.originalNamesAutoComplete.salesPerson = res.salesPerson;

                this.originalSubscriptionLevel = this.subscriptionLevel;

                this.markedInactiveOn = res.markedInactiveOn;
                this.savedCustomerProjectDetails = this.getCurrentCustomerProjectDetails();
                this.uiUtilsService.safeChangeDetection(this.cdr);
                this.customerForm?.form?.markAsPristine();
                this.checkRequiredFields();
            },
            (error) => {
                if (error.status === 404) {
                    //
                }
            },
        );

        this.subscriptions.push(getProjectDetailsSubscription);
    }

    private setSelectedCustomer(customerID: number) {
        if (customerID !== undefined) {
            this.customers.forEach((element) => {
                element.isSelected = element.customerID === customerID;
            });
            this.initialCustomersData.forEach((element) => {
                element.isSelected = element.customerID === customerID;
            });
            this.customerEditorData.forEach((element) => {
                element.isSelected = element.customerID === customerID;
            });
        }
    }

    public archiveCustomer(customerId: number, customerName: string) {
        const dialogSubsription = this.dialog
            .open(ConfirmationDialogComponent, {
                disableClose: true,
                data: {
                    title: this.archiveDialogTitle,
                    message: `${StringUtils.joinWithSingleSpace(this.archieveDialogMsgStart, customerName)}${this.archieveDialogMsgEnd?.trimStart() ?? ''}`,
                    okText: this.archiveBtn,
                    cancelText: this.cancelBtn,
                },
            })
            .afterClosed()
            .subscribe((res) => {
                if (res.whichButtonWasPressed === 'ok') {
                    this.customersLoadingState = true;
                    const subscription = this.customerService.archiveCustomer(customerId).subscribe(
                        (response) => {
                            this.customer = response;
                            this.customersLoadingState = false;
                        },
                        (error) => {
                            this.customersLoadingState = false;
                        },
                    );
                    this.subscriptions.push(subscription);

                    const snackbarRef: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(
                        StringUtils.joinWithSingleSpace(customerName, this.archivedSuccessMsg),
                        this.dismissText,
                    );
                    setTimeout(snackbarRef.dismiss.bind(snackbarRef), 10000);
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                }
            });
        this.subscriptions.push(dialogSubsription);
    }
    public exitCustomerEditor(event: MouseEvent): void {
        event.preventDefault();
        this.doExitCustomerEditor();
    }

    private doExitCustomerEditor(): void {
        // get current query params for customer
        const currentCustomerID = Number(this.activatedRoute.snapshot.queryParamMap.get(customerQueryParam));
        const queryParams: AppQueryParams = {
            c: currentCustomerID,
            s: this.searchValue ? this.searchValue : undefined,
            pi: !this.pageIndex ? 0 : this.pageIndex,
            ps: this.pageSize || undefined,
        };

        if(this.sortValue) {
            queryParams.psa = this.sortValue;
            queryParams.psd = this.sortDirection;
        }
        this.router.navigate(['/pages/customers'], {
            queryParams: queryParams,
            relativeTo: this.activatedRoute
        });
    }

    public resetCustomerForm() {
        this.customerNameLengthIsInvalid = false;
        this.customerShortNameLengthIsInvalid = false;

        if (this.showUpdateCustomerEditor) {
            this.customerName = this.customer.customerName;
            this.flowViewFlag = false;
            this.units = this.customer.unitsType;
            this.dateFormat = this.customer.dateFormat;
            this.timeFormat = this.customer.timeFormat;
            this.timeZone = this.customer.timeZone;
            this.workOrderLink = this.customer.workOrderLink;
            this.idleTimeOut = this.customer.idleTimeOut || IDLE_MESSAGE_MINUTES;
            this.daylightSavingFlag = this.customer.isDaylightSavings;
            this.isValidCustomerName = true;
            this.dataTTL = this.customer.dataTTL;
        } else {
            this.customerName = null;
            this.shortName = null;
            this.flowViewFlag = false;
            this.units = null;
            this.dateFormat = null;
            this.timeFormat = null;
            this.timeZone = null;
            this.workOrderLink = environment.workOrderLink;
            this.idleTimeOut = IDLE_MESSAGE_MINUTES;
            this.daylightSavingFlag = false;
            this.dataTTL = 12;
        }
    }

    public openNewLocationEditor() {
        //  disable "add new location" button on customer editor to prevent multiple dialogs being open
        this.disableAddLocationBtn = true;
        const getLocationsSubscription = this.locationDashboardSvc
            .getLocations(<LocationArgs>{ customerId: this.customerID })
            .subscribe((locations: Array<Locations>) => {
                // Variable to store rain gauge locations
                let rainGaugeLocations = new Array<Locations>();
                // check if locations exist
                if (locations) {
                    // Filter and set rain gauge locations
                    rainGaugeLocations =
                        locations.filter(
                            (location) => location.series && location.series.toLowerCase().indexOf('rainalert') > -1,
                        ) || new Array<Locations>();
                    rainGaugeLocations.sort(this.uiUtilsService.sortLocations);
                }
                const data: AddLocationModalData = {
                    rainGaugeLocations: rainGaugeLocations,
                    customerId: this.customerID,
                    isFromCustomerEditor: true,
                }
                // open add location dialog
                const addDialogSubscription = this.dialog
                    .open<AddLocationComponent, AddLocationModalData, void>(AddLocationComponent, {
                        data: data,
                    })
                    .afterClosed()
                    .subscribe(() => {
                        this.disableAddLocationBtn = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        this.statusCodeService.isLocationCreated.next(true);
                    });
                this.subscriptions.push(addDialogSubscription);
            });
        this.subscriptions.push(getLocationsSubscription);
    }

    clearRegionalManager(event: MouseEvent) {
        this.regionalManager = undefined;
        this.originalNamesAutoComplete.regionalManager = undefined;
        this.autoCompleteCheckChanges();
        event.stopPropagation();
        this.customerForm.controls.contractNumber.markAsDirty();
      }

      clearDataAnalyst(event: MouseEvent) {
        this.dataAnalyst = undefined;
        this.originalNamesAutoComplete.dataAnalyst = undefined;
        this.autoCompleteCheckChanges();
        event.stopPropagation();
        this.customerForm.controls.contractNumber.markAsDirty();
      }

      clearProjectManager(event: MouseEvent) {
        this.projectManager = undefined;
        this.originalNamesAutoComplete.projectManager = undefined;
        this.autoCompleteCheckChanges();
        event.stopPropagation();
        this.customerForm.controls.contractNumber.markAsDirty();
      }

      clearSalesPerson(event: MouseEvent) {
        this.salesPerson = undefined;
        this.originalNamesAutoComplete.salesPerson = undefined;
        this.autoCompleteCheckChanges();
        event.stopPropagation();
        this.customerForm.controls.contractNumber.markAsDirty();
      }

    public addCompositeLocation(): void {
        if (!this.usersService.isMonitorEditor.getValue()) {
            return;
        }

        const data: CompositeLocCreateInput = { customerId: this.customerID };
        const dialogOptions: MatDialogConfig<CompositeLocComponentInput> = {
            disableClose: true,
            data,
        };

        if (this.gisService.locationCardPosition) {
            dialogOptions.position = this.locationCardService.checkLocationCardPosition(false, this.gisService.locationCardPosition);
        }
        this.dialog
            .open<CompositeLocComponent, CompositeLocComponentInput, IComponentModalResult>(
                CompositeLocComponent,
                dialogOptions,
            )
            .afterClosed()
            .subscribe((res) => {
                if (res.success) {
                    this.statusCodeService.isLocationCreated.next(true);
                }
            });
    }

    public closeNewLocationEditor() {
        this.showNewLocationEditor = false;
    }

    public generateCustomerEditorTable() {
        this.customerEditorDataSource = null;
        this.customerEditorDataChange = new BehaviorSubject([]);
        if (this.customers) {
            for (const customer of this.customers) {
                const customerEditorCopiedData = this.customerEditorData.slice();
                const data = {
                    customerName: customer.customerName,
                    customerID: customer.customerID,
                };
                customerEditorCopiedData.push(data);
                this.customerEditorDataChange.next(customerEditorCopiedData);
            }

            this.customerEditorDataSource = new FilterDataSource(
                this.customerEditorDataChange,
                this.customerEditorData,
                this.customerEditorPaginator,
                this.customerEditorSort,
                this.customerEditorFilterColumns,
            );
            this.totalPaginationLength = this.customerEditorData.length;
            this.uiUtilsService.safeChangeDetection(this.cdr);
        } else {
            this.totalPaginationLength = 1;
        }
        this.setSelectedCustomer(this.selectedCustomerID);
    }

    private getCustomerPermission(customerId: number) {
        this.subscriptions.push(
            this.customerService.getCustomer(customerId).subscribe((features) => {
                this.isApiKeyEnabled = features.some((f) => f.id === FEATURE_IDS.API_KEYS);
                this.isCustomAlarmingEnabled = features.some((f) => f.id === FEATURE_IDS.API_KEYS);
            }),
        );
    }

    private manageCustomAlarmsTab(result: boolean) {
        if (result) {
            this.isCustomAlarmingEnabled = false;
        } else {
            this.isCustomAlarmingEnabled = true;
        }
    }
    public setUnit() {
        const unitData = this.units === this.metricValue ? 'mm' : 'in';
        this.customerService.unitValue.next(unitData);
    }

    public onSelectedTabChange(event: MatTabChangeEvent, tabGroup: MatTabGroup): void {
        if (this.domOperationUtilsService.hintPageName === LOCATION_DETAIL_HINT) {
            this.domOperationUtilsService.showLocationDashboardDetailHintOverlay();
        }

        this.tabIndex = event.index;
        this.activeTabId = this.getTabId(event.index);
        this.activePaginationState = this.paginationStates.get(this.activeTabId);
        tabGroup.selectedIndex = event.index;
        this.domOperationUtilsService.currentScreenNo = event.index;
        this.domOperationUtilsService.editCustomerTabIndex.next(event.index);
    }

    public warningDialogOpen(): Observable<IComponentDialogConfirmationResult> {
        const message = true
            ? this.translate.instant('CUSTOMER_EDITOR.NAVIGATE_AWAY_WARNING')
            : this.translate.instant('SLIICER.COMMON.NAVIGATE_AWAY_WARNING');

        return this.dialog.open<ConfirmationDialogComponent, IComponentDialog, IComponentDialogConfirmationResult>(ConfirmationDialogComponent, {
            data: {
                title: this.translate.instant('SLIICER.COMMON.WARNING'),
                message: message,
                cancelText: this.translate.instant('SLIICER.COMMON.CANCEL_BUTTON_TITLE'),
                okText: this.translate.instant('SLIICER.COMMON.CONFIRM'),
                messageClass: 'danger'
            },
            disableClose: true,
        }).afterClosed();
    }

    public dialogConfirmSubscriptionLevel(): Observable<IComponentDialogConfirmationResult> {
        const message = SUBSCRIPTION_LEVELS[this.subscriptionLevel]?.text ? this.translate.instant('CUSTOMER_EDITOR.SAVE_SUBSCRIPTION_LEVEL') + SUBSCRIPTION_LEVELS[this.subscriptionLevel]?.text : '-';

        return this.dialog.open<ConfirmationDialogComponent, IComponentDialog, IComponentDialogConfirmationResult>(ConfirmationDialogComponent, {
            data: {
                title: this.translate.instant('CUSTOMER_EDITOR.SAVE_CUSTOMER_CHANGES'),
                message: message,
                cancelText: this.translate.instant('SLIICER.COMMON.CANCEL_BUTTON_TITLE'),
                okText: this.translate.instant('SLIICER.COMMON.CONFIRM')
            },
            disableClose: true,
        }).afterClosed();
    }

    public addTritonLocation(): void {
        if (!this.usersService.isMonitorEditor.getValue()) {
            return;
        }

        this.disableAddLocationBtn = true;

        const parameters: GetAllRainGaugesParams = {
            CID: this.customerID,
            IncludeInactiveLocations: false,
            IType: RAIN_GAUGE,
            PageSize: 1000,
            StartPage: 1,
        };

        this.customerService.getAllRainGauges(parameters).subscribe((rainLocations: RainLocation[]) => {
            const dialogOptions: MatDialogConfig<LocationCardData> = {
                disableClose: true,
                data: {
                    isFromCustomerEditor: true,
                    rainGaugeLocations: rainLocations,
                    customerId: this.customerID,
                    editMode: false,
                },
            };

            if (this.gisService.locationCardPosition) {
                dialogOptions.position = this.locationCardService.checkLocationCardPosition(true, this.gisService.locationCardPosition);
            }

            if (this.mapService.addEditLocationDialog) {
                this.mapService.addEditLocationDialog.close();
            }

            this.mapService.addEditLocationDialog = this.dialog.open<LocationCardContainerDialogComponent, LocationCardData, boolean>(LocationCardContainerDialogComponent, dialogOptions);
            this.mapService.addEditLocationDialog
                .afterClosed()
                .pipe(first())
                .subscribe((result: boolean) => {
                    this.mapService.addEditLocationDialog = null;
                    this.disableAddLocationBtn = false;
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    if (result) {
                        this.statusCodeService.isLocationCreated.next(true);
                    }
                });
        });
    }

    public setOriginalContractStart(event: MatDatepickerInputEvent<Date | string>) {
        if (event.target) {
            if (event.target.value) {
                if (typeof event.target.value === 'string' && !Number.isNaN(Date.parse(event.target.value))) {
                    this.originalContractStart = new Date(event.target.value);
                } else if (!isNaN((event.target.value as Date).getTime())) {
                    this.originalContractStart = event.target.value as Date;
                }
            } else {
                this.originalContractStart = null;
            }
        }

        // need to mark the form as dirty and can't have this field as a part of the form...
        this.customerForm.controls.contractNumber.markAsDirty();
    }

    public setCurrentContractStart(event: MatDatepickerInputEvent<Date | string>) {
        if (event.target) {
            if (event.target.value) {
                if (typeof event.target.value === 'string' && !Number.isNaN(Date.parse(event.target.value))) {
                    this.currentContractStart = new Date(event.target.value);
                } else if (!isNaN((event.target.value as Date).getTime())) {
                    this.currentContractStart = event.target.value as Date;
                }
            } else {
                this.currentContractStart = null;
            }
        }

        this.customerForm.controls.contractNumber.markAsDirty();
    }

    public setCurrentContractEnd(event: MatDatepickerInputEvent<Date>) {
        if (event.target) {
            if (event.target.value) {
                if (typeof event.target.value === 'string' && !Number.isNaN(Date.parse(event.target.value))) {
                    this.currentContractEnd = new Date(event.target.value);
                } else if (!isNaN((event.target.value as Date).getTime())) {
                    this.currentContractEnd = event.target.value as Date;
                }
            } else {
                this.currentContractEnd = null;
            }
        }

        this.customerForm.controls.contractNumber.markAsDirty();
    }

    public dataAnalystSelected(event: AutoCompleteItem[]) {
        this.dataAnalyst = event.length ? event[0] : undefined;
        this.autoCompleteCheckChanges();
    }
    public projectManagerSelected(event: AutoCompleteItem[]) {
        this.projectManager = event.length ? event[0] : undefined;
        this.autoCompleteCheckChanges();
    }
    public regionalManagerSelected(event: AutoCompleteItem[]) {
        this.regionalManager = event.length ? event[0] : undefined;
        this.autoCompleteCheckChanges();
    }
    public salesPersonSelected(event: AutoCompleteItem[]) {
        this.salesPerson = event.length ? event[0] : undefined;
        this.autoCompleteCheckChanges();
    }

    private autoCompleteCheckSingleChange(nameField: string, acField: AutoCompleteItem) {
        return !((nameField === undefined && acField === undefined) || nameField === acField?.name);
    }

    public autoCompleteCheckChanges() {
        this.autoCompleteModified =
            this.autoCompleteCheckSingleChange(this.originalNamesAutoComplete.dataAnalyst, this.dataAnalyst)
            || this.autoCompleteCheckSingleChange(this.originalNamesAutoComplete.projectManager, this.projectManager)
            || this.autoCompleteCheckSingleChange(this.originalNamesAutoComplete.regionalManager, this.regionalManager)
            || this.autoCompleteCheckSingleChange(this.originalNamesAutoComplete.salesPerson, this.salesPerson);
    }

    public isSubscirpitionLevelChange(): boolean {
        return !!this.savedCustomerProjectDetails
            && this.savedCustomerProjectDetails.subscriptionLevel !== this.normalizeNumber(this.subscriptionLevel);
    }

    public fieldsCheckChanges() {
        this.fieldsModified = this.isSubscirpitionLevelChange();
    }

    public onSubscriptionLevelChange() {
        this.fieldsCheckChanges();
    }
}
